import Lenis from 'lenis';
import { prefersReducedMotion } from './motion/prefersReducedMotion.js';

/**
 * Initializes smooth scroll. Mirrors the Next prototype's SmoothScrollProvider
 * config so dev/prod feel identical. Skipped entirely under prefers-reduced-motion.
 *
 * `autoRaf: false` so we can drive Lenis from GSAP's ticker — this keeps
 * ScrollTrigger pins/scrubs in lockstep with the smoothed scroll position.
 * Without that sync, the timeline scroll-jack section drifts.
 *
 * `data-lenis-prevent` on inner-scroll elements (cart drawer body, etc.) is
 * honored natively by Lenis — no extra wiring needed.
 */
export function initLenis() {
  if (prefersReducedMotion()) return null;

  const lenis = new Lenis({
    autoRaf: false,
    smoothWheel: true,
    syncTouch: false,
    duration: 1.15,
    lerp: 0.085,
    gestureOrientation: 'vertical',
    wheelMultiplier: 0.95,
    touchMultiplier: 1,
    anchors: true,
  });

  // Sync ScrollTrigger to Lenis's scroll position
  lenis.on('scroll', () => window.ScrollTrigger?.update());

  // Drive Lenis from GSAP's ticker so frames stay in lockstep
  window.gsap.ticker.add((time) => lenis.raf(time * 1000));
  window.gsap.ticker.lagSmoothing(0);

  window.lenis = lenis;
  return lenis;
}
